import { countriesToRemove } from '../../utils/countriesToRemove.js';
import { countryOptins } from '../../utils/country-options.js';

export default class DynamicTable {
  constructor() {
    this.jsonData = {};
    this.data = {};
    this.isLoading = true;
    this.countriesToRemove = countriesToRemove;
    this.countryOptins = countryOptins;

    this.loader =
      '<div class="preloader-container-table show"><div class="loader-table"></div></div>';
    this.tableContainer = $('.payment-table-container');
    $('.payment-table-container .informaltable.table-responsive').addClass(
      'hidden'
    );
    this.tableContainer.append(this.loader);
    this.generateTable();

    this.links = this.linksToPMTNames();
  }

  async getJsonData() {
    this.isLoading = true;
    const response = await fetch(`${DOC_URL}services/pmt.json`);
    if (response) {
      this.isLoading = false;
    }
    this.jsonData = await response.json();
  }

  getIsoCountry(country) {
    const entry = this.countryOptins.find((item) => item.label === country);

    return entry ? entry.value.toUpperCase() : null;
  }

  groupDataByNameAndRemoveAfrinicRegion() {
    this.jsonData = this.jsonData.filter((item) => {
      if (typeof item.country === 'string') {
        item.country = item.country.replace(/'/g, '"');
        item.country = JSON.parse(item.country);
      }
      if (item.country && item.country.length > 0) {
        item.country = item.country.filter(
          (country) => !this.countriesToRemove.includes(country?.toUpperCase())
        );
        return item.country.length > 0;
      }
      return false;
    });

    return this.jsonData.reduce((acc, item) => {
      const existingItem = acc.find(
        (groupedItem) =>
          groupedItem.payment_method_type_name === item.payment_method_type_name
      );

      if (existingItem) {
        existingItem.country = Array.from(
          new Set(existingItem.country.concat(item.country))
        );
      } else {
        acc.push({
          ...item,
          country: item.country,
        });
      }
      return acc;
    }, []);
  }
  linksToPMTNames() {
    const links = [];
    const ulElements = document.querySelectorAll('.links ~ ul');
    ulElements.forEach((ul) => {
      ul.querySelectorAll('li').forEach((li) => {
        const title = li.textContent.trim();
        const link = li.querySelector('a').getAttribute('href');
        links.push({ title, link });
      });
    });
    return links;
  }

  async convertJsonData() {
    await this.getJsonData();
    this.jsonData = this.groupDataByNameAndRemoveAfrinicRegion();
    return this.jsonData.map((entry) => ({
      payment_method: entry.payment_method_type_name || '',
      countries:
        typeof entry.country === 'string'
          ? JSON.parse(entry.country)
          : entry.country || [],
      categories:
        typeof entry.catgories === 'string'
          ? JSON.parse(entry.catgories)
          : entry.catgories || [],
      currencies:
        typeof entry.currencies === 'string'
          ? JSON.parse(entry.currencies)
          : entry.currencies || [],
      features: {
        refundable: entry.payment_method_type_is_refundable,
        cancelable: entry.payment_method_type_is_cancelable,
        subscription: entry.subscription_availability,
        dispute: true,
      },
      country_iso_alpha2: entry.payment_method_type_country_iso_alpha2 || '[]',
    }));
  }

  capitalizeAndRemoveUnderscore(str) {
    if (str) {
      return (
        str
          ?.split('_')
          .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`)
          .join(' ') || str
      );
    }
  }
  formatNameWithLink(val) {
    if (val) {
      const foundLink = this.links.find(
        (link) => link.title.toLowerCase() === val.toLowerCase()
      );
      if (foundLink) {
        return `${DOC_URL}en/${foundLink.link}`;
      }
    }
  }

  getFlagURL(country) {
    const countryCode = this.getIsoCountry(country);
    return `../assets/flags/1x1/${countryCode}.svg`;
  }

  getAllUniqueCurrencies() {
    const allCurrencies = this.data.flatMap((row) => row.currencies);
    return [...new Set(allCurrencies)];
  }

  getAllUniqueCountries() {
    const allCountries = this.data.flatMap((row) => row.countries);
    const countries = allCountries.map((country) =>
      this.capitalizeAndRemoveUnderscore(country)
    );
    return [...new Set(countries)];
  }

  getAllUniqueCategories() {
    const allCategories = this.data.flatMap((row) => row.categories);
    return [...new Set(allCategories)];
  }

  generateHeader() {
    const headerRow = $('<tr>');
    const allCurrencies = this.getAllUniqueCurrencies();
    const allCountries = this.getAllUniqueCountries();
    const allCategories = this.getAllUniqueCategories();
    for (const key in this.data[0]) {
      if (key === 'country_iso_alpha2') continue;

      const filterButton =
        key !== 'features'
          ? `<button class='dropbtn'><span class='filter-icon'/></button>`
          : '';
      let dropdownValues;
      if (key === 'categories') {
        dropdownValues = allCategories.map(
          (value) => `
              <label class='custom-checkbox'>
                <input type='checkbox' id='${key}-${value}' value='${value}'>
                <span class='checkmark'></span>
                ${this.capitalizeAndRemoveUnderscore(value)}
              </label>
            `
        );
      } else if (key === 'currencies') {
        dropdownValues = allCurrencies.map(
          (value) => `
              <label class='custom-checkbox'>
                <input type='checkbox' id='${key}-${value}' value='${value}'>
                <span class='checkmark'></span>
                ${value}
              </label>
            `
        );
      } else if (key === 'countries') {
        const countries = allCountries.filter(
          (str) => !str?.includes('dIvoire')
        );
        dropdownValues = countries.map(
          (value) => `
                  <label class='custom-checkbox'>
                    <input type='checkbox' id='${key}-${value}' value='${value}'>
                    <span class='flag-icon' style='--flag-url: url(${this.getFlagURL(
                      value
                    )})'></span>
                    <span class='checkmark'></span>
                    ${this.capitalizeAndRemoveUnderscore(value)}
                  </label>
                `
        );
      } else {
        const uniqueValuesSet = new Set();
        dropdownValues = this.data
          .map((record) => record[key])
          .filter(
            (value, index, self) => value && self.indexOf(value) === index
          )
          .filter((value) => {
            if (!uniqueValuesSet.has(value)) {
              uniqueValuesSet.add(value);
              return true;
            }
            return false;
          })
          .map(
            (value) => `
            <label class='custom-checkbox'>
                <input type='checkbox' id='${key}-${value}' value='${value}'>
                <div className="icon" />
                <span class='checkmark'></span>
                ${
                  key === 'category'
                    ? this.capitalizeAndRemoveUnderscore(value)
                    : value
                }
            </label>
        `
          );
      }
      const resetButton = `<div class='reset-btn-container'><span class='reset-btn-icon'/><button class='reset-btn'>Reset Selection</button></div>`;

      const th = $(`
      <th>
        <div class='dropdown'>
          <span>${this.capitalizeAndRemoveUnderscore(key)}</span>
          ${filterButton}
          <div class='${key}-dropdown-content-container'>
            <div class='dropdown-content' id='${key}-dropdown'>
              <div id='input_container'>
                <input type='text' id='search-dropdown' placeholder='Search' minlength="2" maxlength="25">
              </div>
              <div class='list-container'>
              ${dropdownValues.join('')}
               </div>
               ${resetButton}
            </div>
          </div>
        </div>
      </th>
    `);

      headerRow.append(th);
    }
    return headerRow;
  }

  async generateTable() {
    this.data = await this.convertJsonData();
    if (!this.isLoading) {
      $('.preloader-container-table').removeClass('show');
      $('.preloader-container-table').addClass('hidden');
      $('.payment-table-container .informaltable.table-responsive').removeClass(
        'hidden'
      );
      const table = $('<table id="payments-table">');
      const headerRow = this.generateHeader();
      table.append(headerRow);
      table.append(this.generateTbody(this.data));

      const existingTable = this.tableContainer.find('table');
      if (existingTable.length) {
        existingTable.replaceWith(table);
      } else {
        this.tableContainer.append(table);
      }

      const searchInputs = this.tableContainer.find('input[type="text"]');
      searchInputs.on('input', (event) => {
        const searchText = event.target.value;
        const dropdownContent = $(event.target).closest('.dropdown-content');
        this.filterCheckboxes(searchText, dropdownContent);
      });
    }

    this.listenEvents();
  }

  generateFeatures(features) {
    return ['refundable', 'cancelable', 'subscription', 'dispute'].map(
      (featureKey) => {
        const uiContainer = document.createElement('div');
        const text = document.createElement('span');
        text.className = 'features-text';
        text.textContent = this.capitalizeAndRemoveUnderscore(featureKey);
        uiContainer.className = features[featureKey]
          ? 'check_text'
          : 'delete_text';
        const iconSpan = document.createElement('span');
        iconSpan.className = features[featureKey] ? 'check' : 'delete';
        uiContainer.appendChild(iconSpan);
        uiContainer.appendChild(text);
        return uiContainer;
      }
    );
  }

  generateContent(content) {
    const truncatedContent = document.createElement('div');

    if (
      content.length > 200 ||
      (Array.isArray(content) && content.length > 10)
    ) {
      if (Array.isArray(content)) {
        truncatedContent.textContent = content.slice(0, 4) + '...';
      } else {
        truncatedContent.textContent = content.substring(0, 200) + '...';
      }
      const fullContent = document.createElement('div');
      fullContent.textContent = content;
      fullContent.style.display = 'none';
      const showMoreButton = document.createElement('span');
      showMoreButton.textContent = 'Show More';
      showMoreButton.className = 'show-more-button';
      showMoreButton.addEventListener('click', () => {
        this.toggleTextView(fullContent, truncatedContent, showMoreButton);
      });
      return [truncatedContent, fullContent, showMoreButton];
    } else {
      const fullContent = document.createElement('div');
      fullContent.textContent = content;
      return [fullContent];
    }
  }

  generateTbody(data) {
    const tbody = $('<tbody>');
    data.forEach((record) => {
      const dataRow = $('<tr>');
      for (const key in record) {
        if (key === 'country_iso_alpha2') continue;
        const tableCell = document.createElement('td');
        switch (key) {
          case 'payment_method': {
            const link = this.formatNameWithLink(record[key]);
            const container = document.createElement('div');
            container.className = 'payment_method-container';
            if (link) {
              const a = document.createElement('a');
              a.textContent = record[key];
              a.href = link;
              container.append(a);
            } else {
              container.textContent = record[key];
            }
            tableCell.append(container);
            dataRow.append(tableCell);
            break;
          }
          case 'countries':
            const prettyCountries = record[key].map((val) =>
              this.capitalizeAndRemoveUnderscore(val)
            );
            const newSetprettyCountriesCountries = [
              ...new Set(prettyCountries),
            ];
            const containerCountries = this.generateContent(
              newSetprettyCountriesCountries
            );
            containerCountries.forEach((element) => {
              tableCell.append(element);
            });
            break;
          case 'categories':
            const containerCatgories = document.createElement('div');
            const prettyCatgories = record[key].map((val) =>
              this.capitalizeAndRemoveUnderscore(val)
            );
            const newSet = [...new Set(prettyCatgories)];
            containerCatgories.innerText = newSet;
            tableCell.append(containerCatgories);
            dataRow.append(tableCell);
            break;
          case 'features':
            const container = document.createElement('div');
            container.className = 'features-container';
            const elements = this.generateFeatures(record[key]);
            elements.forEach((element) => {
              container.appendChild(element);
            });
            tableCell.append(container);
            dataRow.append(tableCell);
            break;
          default:
            const elementsGenerated = this.generateContent(record[key]);
            elementsGenerated.forEach((element) => {
              tableCell.append(element);
            });
            break;
        }
        dataRow.append(tableCell);
      }
      tbody.append(dataRow);
    });
    return tbody;
  }

  filterCheckboxes(searchText, dropdownContent) {
    $('.custom-checkbox', dropdownContent).each(function () {
      $(this).toggle(
        $(this).text().toLowerCase().includes(searchText.toLowerCase())
      );
    });
  }

  filterJSON(data, filters) {
    return data.filter((record) => {
      return Object.keys(filters).every((key) => {
        const filterValues = filters[key];

        if (filterValues.length === 0) {
          return true;
        }

        if (
          key === 'currencies' ||
          key === 'countries' ||
          key === 'categories'
        ) {
          return record[key].some((currency) =>
            filterValues.includes(currency)
          );
        } else {
          return filterValues.includes(record[key]);
        }
      });
    });
  }

  filterData(filteredData) {
    this.updateTableBody(filteredData);
  }

  toggleTextView(fullContent, truncatedContent, showMoreButton) {
    const isHidden = fullContent.style.display === 'none';

    if (isHidden) {
      fullContent.style.display = 'inline';
      truncatedContent.style.display = 'none';
      showMoreButton.textContent = 'Show Less';
    } else {
      fullContent.style.display = 'none';
      truncatedContent.style.display = 'inline'; // Set truncated content to display
      showMoreButton.textContent = 'Show More';
    }
  }

  updateTableBody(filteredData) {
    const table = this.tableContainer.find('table');
    const tbody = table.find('tbody');

    tbody.empty();
    const tbodyDom = this.generateTbody(filteredData, tbody);
    table.append(tbodyDom);
  }

  updateSelectedFilters(container, key, values) {
    container.innerHTML = '';

    if (values.length > 0) {
      values.forEach((value) => {
        const filterItem = document.createElement('div');
        filterItem.className = 'selected-filter';
        filterItem.textContent = `${key}: ${value}`;

        const removeIcon = document.createElement('span');
        removeIcon.className = 'remove-filter-icon';
        removeIcon.addEventListener('click', () => {
          // Remove the filter when the remove icon is clicked
          const index = filters[key].indexOf(value);
          if (index !== -1) {
            filters[key].splice(index, 1);
          }
          checkbox.checked = false;

          const filteredData = this.filterJSON(this.data, filters);
          this.filterData(filteredData);

          this.updateSelectedFilters(container, key, filters[key]);
        });

        filterItem.appendChild(removeIcon);
        container.appendChild(filterItem);
      });
    }
  }

  listenEvents() {
    const dropdownContents = document.querySelectorAll('.dropdown-content');
    const filters = {};

    dropdownContents.forEach((content) => {
      const checkboxes = content.querySelectorAll('input[type="checkbox"]');
      const dropdownTrigger = content
        .closest('.dropdown')
        .querySelector('.dropbtn');
      const resetButton = content.querySelector('.reset-btn-container');
      const filterIcon = dropdownTrigger.querySelector('.filter-icon');
      const selectedFiltersContainer = content.querySelector(
        '.selected-filters-container'
      );

      let isCheckboxChecked = false;

      dropdownTrigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const isHidden = content.style.display === 'none';
        dropdownTrigger.className =
          isHidden && isCheckboxChecked ? 'bth-click' : 'dropbtn';
        dropdownContents.forEach((otherContent) => {
          if (otherContent !== content) {
            otherContent.style.display = 'none';
          }
        });
        content.style.display = isHidden ? 'block' : 'none';

        if (!isHidden) {
          const filteredData = this.filterJSON(this.data, filters);
          this.filterData(filteredData);
        }
      });

      filterIcon.addEventListener('click', (event) => {
        event.stopPropagation();
        content.style.display = 'none';
      });

      resetButton.addEventListener('click', (event) => {
        event.stopPropagation();
        const searchInput = $(event.target)
          .closest('.dropdown-content')
          .find('#search-dropdown');
        searchInput.val('');

        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
        const key = checkboxes[0].id.split('-')[0];
        filters[key] = [];

        dropdownTrigger.className = 'dropbtn';

        searchInput.trigger('input');

        const filteredData = this.filterJSON(this.data, filters);
        this.filterData(filteredData);
      });

      checkboxes.forEach((checkbox, index) => {
        checkbox.addEventListener('click', (event) => {
          event.stopPropagation();
          isCheckboxChecked = Array.from(checkboxes).some((chk) => chk.checked);
          dropdownTrigger.className = isCheckboxChecked
            ? 'bth-click'
            : 'dropbtn';

          checkboxes.forEach((checkbox) => {
            const key = checkbox.id.split('-')[0];
            const value = checkbox.value;

            filters[key] = Array.from(checkboxes)
              .filter((chk) => chk.checked && chk.value !== 'all')
              .map((chk) => chk.value);

            const filteredData = this.filterJSON(this.data, filters);
            this.filterData(filteredData);

            this.updateSelectedFilters(
              selectedFiltersContainer,
              key,
              filters[key]
            );
          });
        });
      });

      document.addEventListener('click', (event) => {
        const targetElement = event.target;
        if (
          !content.contains(targetElement) &&
          !dropdownTrigger.contains(targetElement) &&
          !filterIcon.contains(targetElement)
        ) {
          content.style.display = 'none';
        }
      });
    });
  }

  stopListening() {}
}
